export default __webpack_public_path__ + "static/media/tutorial.595c5f59.svg";